import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { getSerialNumber } from '@/components/dataTable/data-table.utils';
import { EditIcon } from '@/icons/edit';
import { EyeIcon } from '@/icons/eye';
import { ApiLog } from '@/services/logsManagement/logsMangement.types';

import type { ColumnDef } from '@tanstack/react-table';

export function getColumns(): ColumnDef<ApiLog>[] {
  return [
    {
      accessorKey: 'sn',
      header: ({ column }) => <DataTableColumnHeader column={column} title="S.N" />,
      cell: ({ row, table }) => <div className="font-medium">{getSerialNumber(table, row.index)}</div>,
      enableSorting: false,
    },
    {
      accessorKey: 'code',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Code" />,
      cell: ({ row }) => <div className="font-mono">{row.getValue('code')}</div>,
      meta: {
        label: 'Code',
      },
    },
    {
      accessorKey: 'category',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Category" />,
      cell: ({ row }) => <div>{row.getValue('category')}</div>,
      meta: {
        label: 'Category',
      },
    },
    {
      accessorKey: 'message',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Message" />,
      cell: ({ row }) => (
        <div className="truncate max-w-[30rem] text-sm text-foreground-detail">{row.getValue('message')}</div>
      ),
      meta: {
        label: 'Message',
      },
    },
    {
      accessorKey: 'createdDate',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Created On" />,
      cell: ({ row }) => {
        const raw = row.getValue('createdDate');
        const formatted = new Date(raw as string).toLocaleString();
        return <div>{formatted}</div>;
      },
      meta: {
        label: 'Created On',
      },
    },
    {
      id: 'actions',
      accessorKey: 'actions',
      cell: () => {
        return (
          <div className="flex gap-4">
            <EyeIcon color="var(--warning)" />
            <EditIcon color="var(--foreground-subtle)" />
          </div>
        );
      },
      size: 40,
    },
  ];
}
